import { MapPin, ArrowDown } from "lucide-react";
import { PROJECT } from "@/data/project";

const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden"
    >
      {/* Status banner */}
      <div
        data-testid="hero-status-banner"
        className="absolute top-0 inset-x-0 z-20 bg-[var(--co-primary-deep)]/95 backdrop-blur-sm text-white border-b border-white/10"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-2.5 flex flex-wrap items-center justify-center gap-x-6 gap-y-1 text-[11px] uppercase tracking-[0.25em]">
          <span className="inline-flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--co-accent-light)] animate-pulse" />
            Supermercado en construcción
          </span>
          <span className="inline-flex items-center gap-2 text-white/70">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--co-accent)]" />
            Estación Delta ya operando
          </span>
        </div>
      </div>

      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://customer-assets.emergentagent.com/job_trusting-ritchie-2/artifacts/skla577s_DJI_0306.JPG')",
        }}
      />
      <div className="absolute inset-0 hero-overlay" />
      <div className="absolute inset-0 grain-overlay" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 pt-32 pb-20 min-h-[100svh] flex flex-col justify-center">
        <div className="max-w-3xl">
          <div className="reveal flex items-center gap-3 mb-8">
            <span className="h-px w-12 bg-[var(--co-accent)]" />
            <span className="text-[var(--co-accent)] uppercase tracking-[0.3em] text-xs font-semibold">
              Plaza Comercial · 2026
            </span>
          </div>

          <h1 className="reveal reveal-delay-1 font-display text-white font-black text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] leading-[0.95] tracking-tighter">
            Costa Oeste
            <br />
            <span className="text-[var(--co-accent-light)]">Plaza.</span>
          </h1>

          <p className="reveal reveal-delay-2 mt-8 text-white/85 text-lg md:text-xl max-w-2xl leading-relaxed">
            La nueva plaza comercial al frente de la <strong className="text-white">Ciudad Judicial</strong>{" "}
            y en la <strong className="text-white">única entrada</strong> del Residencial Costa Oeste —
            3,000 familias pasan por aquí a diario, y 3,000 nuevas vienen en construcción. Estación <strong className="text-white">Delta ya operando</strong>.
          </p>

          <div className="reveal reveal-delay-3 mt-10 flex flex-wrap gap-4">
            <a
              data-testid="hero-cta-primary"
              href="#contacto"
              className="inline-flex items-center gap-3 bg-[var(--co-accent)] hover:bg-[var(--co-accent-light)] text-white px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] transition-all shadow-lg hover:shadow-2xl"
            >
              Reservar mi local
            </a>
            <a
              data-testid="hero-cta-secondary"
              href="#renders"
              className="inline-flex items-center gap-3 border border-white/40 text-white hover:bg-white hover:text-[var(--co-primary)] px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] transition-all"
            >
              ver renders
            </a>
          </div>

          <div className="reveal reveal-delay-4 mt-16 flex items-center gap-3 text-white/70 text-sm">
            <MapPin className="w-4 h-4 text-[var(--co-accent-light)]" />
            <span>{PROJECT.location}</span>
          </div>
        </div>

        <a
          href="#ubicacion"
          data-testid="hero-scroll-indicator"
          className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/60 hover:text-white transition-colors flex flex-col items-center gap-2"
        >
          <span className="text-[10px] uppercase tracking-[0.3em]">Explorar</span>
          <ArrowDown className="w-4 h-4 animate-bounce" />
        </a>
      </div>
    </section>
  );
};

export default Hero;
